export default __webpack_public_path__ + "static/media/view-map@2x.3ded169b.png";